export default {"src":"/_next/static/media/Group 427320987.e206887b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};